import styled from 'styled-components';

import { SupplierSubscriptionPlan } from '../../../types/SupplierGroupSubscriptionMessage';
import { Text } from '../../cdl/Text/Text';
import { GetSupplierSubscriptionPlansResponse } from '../../common/api/clients/supplierSubscriptionPlans.api';
import { translate } from '../../common/helpers/translate.helper';
import { theme } from '../../common/ui/theme';

import { ProfessionalSubscriptionPlanPricing } from './ProfessionalSubscriptionPlanPricing';
import { SupplierSubscriptionPlanCard } from './SupplierSubscriptionPlanCard';
import { SupplierSubscriptionPlanNotes } from './SupplierSubscriptionPlanNotes';
import { SupplierSubscriptionPlanPricing } from './SupplierSubscriptionPlanPricing';

const PlansGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: stretch;
    gap: ${theme.space[12]};

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

interface SupplierSubscriptionPlanComparisonProps extends GetSupplierSubscriptionPlansResponse {
    currentPlan: SupplierSubscriptionPlan;
}

export const SupplierSubscriptionPlanComparison = ({ plans, currentPlan }: SupplierSubscriptionPlanComparisonProps) => {
    const basic = plans.find((plan) => plan.plan === SupplierSubscriptionPlan.BASIC);
    const professional = plans.find((plan) => plan.plan === SupplierSubscriptionPlan.PROFESSIONAL);
    if (!basic || !professional) {
        throw new Error('Supplier subscription plan catalog is incomplete');
    }

    return (
        <>
            <PlansGrid>
                <SupplierSubscriptionPlanCard
                    plan={SupplierSubscriptionPlan.BASIC}
                    currentPlan={currentPlan}
                    description={translate('supplierSubscriptionPlans.basicDescription')}
                >
                    <SupplierSubscriptionPlanPricing
                        price={<Text variant="title">{translate('supplierSubscriptionPlans.free')}</Text>}
                        priceNote={
                            <Text variant="extraSmall" color="foreground.muted">
                                {translate('supplierSubscriptionPlans.groupScope')}
                            </Text>
                        }
                        transactionFee={
                            <Text variant="fieldLabel">
                                {translate('supplierSubscriptionPlans.transactionFee', {
                                    percentage: String(basic.transactionFeePercentage),
                                })}
                            </Text>
                        }
                    />
                </SupplierSubscriptionPlanCard>
                <SupplierSubscriptionPlanCard
                    plan={SupplierSubscriptionPlan.PROFESSIONAL}
                    currentPlan={currentPlan}
                    description={translate('supplierSubscriptionPlans.professionalDescription')}
                >
                    <ProfessionalSubscriptionPlanPricing plan={professional} />
                </SupplierSubscriptionPlanCard>
                <SupplierSubscriptionPlanCard
                    plan={SupplierSubscriptionPlan.ENTERPRISE}
                    currentPlan={currentPlan}
                    description={translate('supplierSubscriptionPlans.enterpriseDescription')}
                >
                    <SupplierSubscriptionPlanPricing
                        price={<Text variant="title">{translate('supplierSubscriptionPlans.talkToSales')}</Text>}
                        priceNote={
                            <Text variant="extraSmall" color="foreground.muted">
                                {translate('supplierSubscriptionPlans.customAgreement')}
                            </Text>
                        }
                        transactionFee={
                            <Text variant="fieldLabel">{translate('supplierSubscriptionPlans.customFee')}</Text>
                        }
                    />
                </SupplierSubscriptionPlanCard>
            </PlansGrid>
            <SupplierSubscriptionPlanNotes professional={professional} />
        </>
    );
};
